import { useCallback } from 'react';

import { useNotifications } from '@/features/notifications';
import { OpportunityDetails } from '@/features/opportunities/types';
import { useUpdateProjectMutation } from '@/features/projects';
import { useUpdateOpportunityMutation } from '..';

export function useSendForRevision(opportunity: OpportunityDetails | null) {
  const [projectMutation] = useUpdateProjectMutation();
  const [opportunityMutation] = useUpdateOpportunityMutation();
  const { add } = useNotifications();

  return useCallback(() => {
    if (!opportunity) return;

    const projects = opportunity.projects
      .filter((project) => project.details?.isDraft)
      .map((project) => project.details?.id);

    const projectIds = projects.filter((id): id is string => Boolean(id));
    if (projectIds.length === 0) return;

    Promise.all([
      
      projectIds.map((projectId) =>
        projectMutation({ id: projectId, data: { status: 'pending' } }).unwrap()
      ),
      opportunityMutation({id: opportunity.id, data: { status: 'pending' } }).unwrap(),

    ])
      .then(() => {
        add({
          id: new Date().toString(),
          title: 'Sent for revision',
          description: 'All projects have been successfully sent for review.',
        });
      })
      .catch(() => {
        add({
          id: new Date().toString(),
          title: 'ERROR',
          description: 'There was an error sending one or more projects for revision. Please try again later.',
        });
      });

  }, [opportunity, projectMutation, add]);
}
